import React, { FC } from "react";
import { InputNumber, InputSelect, InputText } from "../../../../components/input";
import { IInputArrayFormProps, IInputArrayDataStructureItem } from "../../../../components/input/arrayData";
import { CreateNotification } from "../../../../components/notifier";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";
import { InputSelectTag } from "../../../../components/input/select-tag";

const eSystemOptions = [
  {
    label: "CM",
    value: "CM",
  },
  {
    label: "FM",
    value: "FM",
  },
  {
    label: "CM và FM",
    value: "CM và FM",
  },
];

const eUserGroupsOptions = [
  {
    label: "Quản lý",
    value: "Quản lý",
  },
  {
    label: "SUP",
    value: "SUP",
  },
  {
    label: "Nhân viên",
    value: "Nhân viên",
  },
  {
    label: "Viewer",
    value: "Viewer",
  },
];

const eOfficeOptions = [
  {
    label: "SGNVN00CI",
    value: "SGNVN00CI",
  },
  {
    label: "SGNVN00SU",
    value: "SGNVN00SU",
  },
  {
    label: "SGNVN00VI",
    value: "SGNVN00VI",
  },
  {
    label: "HANVN00CI",
    value: "HANVN00CI",
  },
  {
    label: "HANVN00SU",
    value: "HANVN00SU",
  },
  {
    label: "HANVN00VI",
    value: "HANVN00VI",
  },
  {
    label: "DADVN00SU",
    value: "DADVN00SU",
  },
  {
    label: "DADVN00VI",
    value: "DADVN00VI",
  },
  {
    label: "DADVN00CI",
    value: "DADVN00CI",
  },
  {
    label: "SGNVN0001",
    value: "SGNVN0001",
  },
  {
    label: "HANVN0001",
    value: "HANVN0001",
  },
  {
    label: "DADVN0001",
    value: "DADVN0001",
  },
];

const DutyCodeOptions = [
  {
    label: "GS",
    value: "GS",
  },
  {
    label: "SU",
    value: "SU",
  },
];

export const ChangeCodeEprProcessContentStructure: IInputArrayDataStructureItem[] = [
  {
    name: "Users",
    label: "Người sử dụng",
    isVisibleOnList: true,
  },
  {
    name: "EmployeeCode",
    label: "Mã nhân viên",
    isVisibleOnList: true,
  },
  {
    name: "WorkingDepartment",
    label: "Bộ phận công tác",
    isVisibleOnList: true,
  },
  {
    name: "Title",
    label: "Chức danh",
    isVisibleOnList: true,
  },
  {
    name: "System",
    label: "Hệ thống",
    isVisibleOnList: true,
  },
  {
    name: "FunctionCode",
    label: "Nhóm User",
    isVisibleOnList: true,
  },
  {
    name: "CaseHasBeenGranted",
    label: "User ID đã được cấp",
    isVisibleOnList: true,
  },
  {
    name: "DutyCode",
    label: "Duty Code",
    isVisibleOnList: true,
  },
  {
    name: "Office",
    label: "Office",
    isVisibleOnList: true,
  },
  {
    name: "Request",
    label: "Đề Nghị",
    isVisibleOnList: true,
  },
  {
    name: "DetailedDescriptionOfTheRequest",
    label: "Chi tiết đề nghị",
    isVisibleOnList: true,
  },
  {
    name: "CodePcc",
    label: "Sân bay trực thuộc (SGN/HAN/DAD/ALL)",
    isVisibleOnList: true,
  },
  {
    name: "Email",
    label: "Email",
    isVisibleOnList: true,
  },
  {
    name: "PhoneNumber",
    label: "Số điện thoại",
    isVisibleOnList: true,
  },
  {
    name: "IdUser",
    label: "CMND/CCCD",
    isVisibleOnList: true,
  },
];

export const ChangeCodeEprProcessContentForm: FC<IInputArrayFormProps> = (props) => {
  const { childFormData } = props;
  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      const clonedValues = { ...values };
      const { FunctionCode, Office } = values;

      clonedValues.FunctionCode = FunctionCode?.value || FunctionCode;
      clonedValues.Office = Office?.value || Office;

      if (
        !clonedValues.Users ||
        !clonedValues.EmployeeCode ||
        !clonedValues.WorkingDepartment ||
        !clonedValues.Title ||
        !clonedValues.Email ||
        !clonedValues.PhoneNumber ||
        !clonedValues.IdUser ||
        !clonedValues.FunctionCode ||
        !clonedValues.System ||
        !clonedValues.Office ||
        !clonedValues.CaseHasBeenGranted ||
        !clonedValues.DutyCode
      )
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
      else props.onSubmit(clonedValues);
    },
  });

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>

      <InputWraper inputProps={getInputProps("Users")} renderInput={(s) => <InputText {...s} error />} isRequired />

      <InputWraper inputProps={getInputProps("EmployeeCode")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("WorkingDepartment")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper inputProps={getInputProps("Title")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("System")}
        renderInput={(s) => <InputSelectTag {...s} options={eSystemOptions} placeholder="* Vui lòng chọn hệ thống" />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("FunctionCode")}
        renderInput={(s) => <InputSelect {...s} options={eUserGroupsOptions} placeholder="* Vui lòng chọn nhóm user" />}
        isRequired
      />

      <InputWraper inputProps={getInputProps("CodePcc")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("Email")} renderInput={(s) => <InputText {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("PhoneNumber")} renderInput={(s) => <InputNumber {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("IdUser")} renderInput={(s) => <InputNumber {...s} />} isRequired />
      <InputWraper
        inputProps={getInputProps("CaseHasBeenGranted")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />
      <InputWraper
        inputProps={getInputProps("DutyCode")}
        renderInput={(s) => <InputSelectTag {...s} options={DutyCodeOptions} placeholder="* Vui lòng chọn Duty Code" />}
        isRequired
      />
      <InputWraper
        inputProps={getInputProps("Office")}
        renderInput={(s) => <InputSelect {...s} options={eOfficeOptions} placeholder="* Vui lòng chọn Office" />}
        isRequired
      />
      <InputWraper inputProps={getInputProps("Request")} renderInput={(s) => <InputText {...s} />} />
      <InputWraper
        inputProps={getInputProps("DetailedDescriptionOfTheRequest")}
        renderInput={(s) => <InputText {...s} />}
      />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
